import { render, staticRenderFns } from "./sign-out.vue?vue&type=template&id=cb08ecb2&"
import script from "./sign-out.vue?vue&type=script&lang=js&"
export * from "./sign-out.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports